import script from "./countdown-seconds.vue?vue&type=script&setup=true&lang=ts"
export * from "./countdown-seconds.vue?vue&type=script&setup=true&lang=ts"

import "./countdown-seconds.vue?vue&type=style&index=0&id=077d38de&lang=css"

const __exports__ = script;

export default __exports__